export default __webpack_public_path__ + "static/media/offer-icon.1e1f0053.svg";